var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigninwithapple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "44px",
    viewBox: "0 0 35 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Black Logo Square") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black-Logo-Square",
    transform: "translate(-10, -6)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.675,17 C30.6718751,17 33.175,15.5454544 34.6656251,13.6060606 C36.0156251,11.8484847 37,9.39393941 37,6.93939384 C37,6.60606059 36.9718751,6.27272734 36.9156251,6 C34.69375,6.09090911 32.0218751,7.60606059 30.41875,9.63636355 C29.1531251,11.1818182 28,13.6060606 28,16.0909091 C28,16.4545453 28.0562502,16.8181818 28.0843751,16.9393938 C28.225,16.969697 28.45,17 28.675,17 Z M21.1835939,50 C23.8359375,50 25.0117189,48.2020117 28.3203125,48.2020117 C31.6835939,48.2020117 32.421875,49.9446772 35.375,49.9446772 C38.2734375,49.9446772 40.2148439,47.2338643 42.046875,44.5783739 C44.0976561,41.5356244 44.9453125,38.5481979 45,38.409891 C44.8085939,38.3545684 39.2578125,36.0586755 39.2578125,29.6135792 C39.2578125,24.0259849 43.6328125,21.5088013 43.8789061,21.3151718 C40.9804689,17.1106454 36.578125,17 35.375,17 C32.1210939,17 29.46875,18.9916178 27.8007811,18.9916178 C25.9960939,18.9916178 23.6171875,17.1106454 20.8007811,17.1106454 C15.4414061,17.1106454 10,21.5917854 10,30.056161 C10,35.3118189 12.0234375,40.8717519 14.5117189,44.4677283 C16.6445311,47.5104778 18.5039061,50 21.1835939,50 Z",
    id: "\\uF8FF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninwithapple);
export default __webpack_public_path__ + "static/media/signinwithapple.063b33fec56babb586ddeb630348e731.svg";
export { ForwardRef as ReactComponent };